module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-8 23a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-3.648c0-.552.308-1.328.75-1.66.93-.7 2.068-1.178 3.25-1.442v-.804c-1.192-.694-2-1.97-2-3.446 0-2.208 1.792-4 4-4s4 1.792 4 4c0 1.476-.808 2.752-2 3.446v.804c1.182.264 2.32.742 3.25 1.442.442.332.75 1.106.75 1.66V23z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/profile-1.js
// module id = 1359
// module chunks = 14